import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all module privileges
export const getModulePrivileges = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/module-privileges`);
    return response.data;
  } catch (error) {
    console.error('Error fetching module privileges:', error.response?.data || error);
    throw error;
  }
};

// GET a single module privilege
export const getModulePrivilegeById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/module-privileges/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching module privilege:', error.response?.data || error);
    throw error;
  }
};

// CREATE a new module privilege
export const createModulePrivilege = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/module-privileges`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating module privilege:', error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing module privilege
export const updateModulePrivilege = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/module-privileges/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating module privilege:', error.response?.data || error);
    throw error;
  }
};

// DELETE a module privilege
export const deleteModulePrivilege = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/module-privileges/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting module privilege:', error.response?.data || error);
    throw error;
  }
};
